import axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import router from '../router';

// axios 配置
axios.defaults.timeout = 20000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.baseURL = '/tengsaiApi/d-web';
axios.defaults.withCredentials = true;

// POST传参序列化
axios.interceptors.request.use(
    config => {
        if (config.method === 'post') {
            if (config.headers['Content-Type'] !== 'multipart/form-data') {
                config.data = qs.stringify(config.data);
            }
        }
        return config;
    },
    error => {
        console.log('参数错误');
        return Promise.reject(error);
    },
);

// 返回状态判断
axios.interceptors.response.use(
    res => {
        if (!res.data.success && res.config.url.indexOf('getUserInfo') < 0) {
            if (res.data.code === '20001') {
                router.push({ path: '/login' });
            }
            Message.error(res.data.message);
            return Promise.reject(res);
        }
        return res;
    },
    error => {
        console.log('网络异常');
        return Promise.reject(error);
    },
);

export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, { params })
            .then(response => {
                resolve(response.data.result);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export function uploadFile(url, params) {
    const param = new FormData();
    Object.keys(params)
        .filter(key => params[key])
        .forEach(key => {
            param.append(key, params[key]);
        });
    const config = {
        headers: { 'Content-Type': 'multipart/form-data' },
    };
    console.log(param.get('title'));
    return new Promise((resolve, reject) => {
        axios
            .post(url, param, config)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
}
